import { getDatadogInstance } from '@cw-elements/analytics-provider';
import { getSelectedCompany } from 'entities/company/company.selectors';
import { getSelectedProperty } from 'entities/property/property.selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const useInitMonitoring = () => {
  const selectedOrg = useSelector(getSelectedCompany);
  const propertyInfo = useSelector(getSelectedProperty);

  useEffect(() => {
    if (selectedOrg?.id) {
      getDatadogInstance()?.setGlobalContextProperty('organizationInfo', {
        id: selectedOrg?.id,
        name: selectedOrg?.name
      });
    }
  }, [selectedOrg?.id, selectedOrg?.name]);

  useEffect(() => {
    if (propertyInfo?.id) {
      getDatadogInstance()?.setGlobalContextProperty('propertyInfo', {
        id: propertyInfo?.id,
        name: propertyInfo?.name
      });
    }
  }, [propertyInfo?.id, propertyInfo?.name]);
};

export default useInitMonitoring;
